module.exports = __webpack_public_path__ + "img/info.d5a1bc93.svg";